<template lang="pug">
  div(class="error-layout")
    v-container(class="h-100")
      div(class="error-layout__content-wrapper")
        m-block-error-card(
          :card-max-width="errorCardMaxWidth"
          :image="errorImage"
          :title="errorTitle"
          :text="errorMessage"
          :button-text="errorButtonText"
        )
          template(
            v-if="noAccessToDocumentError && !authToken"
            v-slot:bottom
          )
            div(class="additional-info")
              div(
                v-for="(card, idx) in cards"
                :key="idx"
                class="additional-card"
              )
                div(class="additional-card__image")
                  v-img(
                    :src="card.image"
                    :max-width="16"
                  )
                h5(class="text-14px dark mb-2") {{ card.title }}
                div(class="text-12px") {{ card.text }}
</template>
<script>
import MBlockErrorCard from '~/components/modules/blocks/concrete/m-block-error-card'
import authData from '~/modules/auth/mixins/authData'
export default {
  components: { MBlockErrorCard },
  layout: 'layoutWithoutDrawer',
  mixins: [authData],
  props: {
    // eslint-disable-next-line vue/require-default-prop
    error: [String, Error, Object]
  },
  computed: {
    errorCode() {
      return this._.get(this.error, 'response.data.code') || this._.get(this.error, 'statusCode')
    },
    noAccessError() {
      return this.errorCode === 403
    },
    noAccessToDocumentError() {
      return this.errorCode === 401
    },
    manyRequestsError() {
      return this.errorCode === 429
    },
    errorCardMaxWidth() {
      if (this.noAccessToDocumentError) {
        if (this.authToken) {
          return 584
        } else {
          return 730
        }
      }
      return 500
    },
    errorImage() {
      if (this.noAccessToDocumentError) {
        return {
          src: require('~/assets/images/warning-gray-box.png'),
          width: '80px'
        }
      } else if (this.manyRequestsError) {
        return {
          src: require('~/assets/images/racoons/racoon-429.svg'),
          width: '400px'
        }
      } else if (this.noAccessError) {
        return {
          src: require('~/assets/images/racoons/racoon-403.svg'),
          width: '400px'
        }
      }
      return {
        src: require('~/assets/images/racoons/racoon-404.svg'),
        width: '400px'
      }
    },
    errorTitle() {
      if (this.noAccessToDocumentError) {
        return this.$t('Link is not valid anymore')
      }
      return null
    },
    errorMessage() {
      if (this.manyRequestsError) {
        return this.$t(
          'Sorry, you have made too many requests in a short time. Please try again in a few minutes'
        )
      } else if (this.noAccessToDocumentError) {
        return this.$t(
          'It may have expired, or the document may have been deleted or modified by the owner'
        )
      }

      return this.$t(
        this._.get(this.error, 'response.data.message') ||
          this._.get(this.error, 'response.data.detail') ||
          this._.get(this.error, 'message')
      )
    },
    errorButtonText() {
      if (this.noAccessToDocumentError) {
        return this.authToken ? this.$t('Go to documents') : this.$t('Create my document')
      }
      return this.$t('Come back to main page')
    },
    cards() {
      return [
        {
          image: require('~/assets/images/message-pen.png'),
          title: this.$t('Send and sign'),
          text: this.$t(
            'Documents from any device using Diya, KEP (electronic digital signature) or SmartID'
          )
        },
        {
          image: require('~/assets/images/lock-with-key.png'),
          title: this.$t('Secure and official'),
          text: this.$t('All signatures comply with legal requirements and have legal force')
        },
        {
          image: require('~/assets/images/lightning.png'),
          title: this.$t('Fast and simple'),
          text: this.$t('Forget about paper and mail. Sign documents in minutes')
        }
      ]
    }
  }
}
</script>
<style lang="scss">
.error-layout {
  width: 100%;
  height: 100%;

  background: $background-primary;

  &__content-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.additional-info {
  border-top: 1px solid #f1f1f1;
  margin-top: 56px;
  padding-top: 32px;

  display: flex;
  align-items: center;
  justify-content: space-between;
}
.additional-card {
  text-align: left;
  max-width: 222px;
  width: 100%;
  padding: 12px;

  &__image {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 12px;

    width: 40px;
    height: 40px;
    background: $background-gray;
    border-radius: 10px;
  }
}
</style>
